// Runtime config from Vite env (see .env.example). Dev defaults let the app run
// against `make stack-up` + `make tiles-serve` with no .env at all.
export const config = {
  apiBase: import.meta.env.VITE_API_BASE ?? 'http://localhost:8080',
  tilesUrl:
    import.meta.env.VITE_TILES_URL ??
    'pmtiles://http://localhost:8081/north-america.pmtiles',
  // Supabase project the admin panel signs in against. Both values are
  // publishable (they ship in the JS bundle). The dev-default key is the
  // local CLI's publishable key (`supabase status`).
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? 'http://127.0.0.1:54321',
  supabaseAnonKey:
    import.meta.env.VITE_SUPABASE_ANON_KEY ??
    'sb_publishable_ACJWlzQHlZjBrEguHvfOxg_3BJgxAaH',
} as const;
